export default __webpack_public_path__ + "static/media/bg-tile-1.a5e0ab74.webp";